import React from 'react';
import { I18n } from 'react-redux-i18n';

import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { filter, map, cloneDeep, forEach, remove } from 'lodash';
import CustomMenu from './CustomMenu';
import CcCheckbox from '../ccCheckbox/CcCheckbox';
import './style.scss';
import { center } from 'react-dom-factories';

const addIcon = `
  <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.50002 7.49935V9.66602C6.50002 9.80768 6.54797 9.9264 6.64385 10.0222C6.73974 10.1181 6.85852 10.166 7.00019 10.166C7.14197 10.166 7.26069 10.1181 7.35635 10.0222C7.45213 9.9264 7.50002 9.80768 7.50002 9.66602V7.49935H9.66669C9.80835 7.49935 9.92708 7.4514 10.0229 7.35552C10.1187 7.25963 10.1667 7.14085 10.1667 6.99918C10.1667 6.8574 10.1187 6.73868 10.0229 6.64302C9.92708 6.54724 9.80835 6.49935 9.66669 6.49935H7.50002V4.33268C7.50002 4.19102 7.45208 4.07229 7.35619 3.97652C7.2603 3.88063 7.14152 3.83268 6.99985 3.83268C6.85808 3.83268 6.73935 3.88063 6.64369 3.97652C6.54791 4.07229 6.50002 4.19102 6.50002 4.33268V6.49935H4.33335C4.19169 6.49935 4.07297 6.54729 3.97719 6.64318C3.8813 6.73907 3.83335 6.85785 3.83335 6.99952C3.83335 7.14129 3.8813 7.26002 3.97719 7.35568C4.07297 7.45146 4.19169 7.49935 4.33335 7.49935H6.50002ZM7.00119 13.3327C6.12519 13.3327 5.3018 13.1665 4.53102 12.834C3.76024 12.5016 3.0898 12.0504 2.51969 11.4805C1.94958 10.9106 1.49819 10.2405 1.16552 9.47002C0.832965 8.69957 0.666687 7.87641 0.666687 7.00052C0.666687 6.12452 0.832909 5.30113 1.16535 4.53035C1.4978 3.75957 1.94896 3.08913 2.51885 2.51902C3.08874 1.9489 3.75891 1.49752 4.52935 1.16485C5.2998 0.832293 6.12296 0.666016 6.99885 0.666016C7.87485 0.666016 8.69824 0.832238 9.46902 1.16468C10.2398 1.49713 10.9102 1.94829 11.4804 2.51818C12.0505 3.08807 12.5019 3.75824 12.8345 4.52868C13.1671 5.29913 13.3334 6.12229 13.3334 6.99818C13.3334 7.87418 13.1671 8.69757 12.8347 9.46835C12.5022 10.2391 12.0511 10.9096 11.4812 11.4797C10.9113 12.0498 10.2411 12.5012 9.47069 12.8338C8.70024 13.1664 7.87708 13.3327 7.00119 13.3327ZM7.00002 12.3327C8.48891 12.3327 9.75002 11.816 10.7834 10.7827C11.8167 9.74935 12.3334 8.48824 12.3334 6.99935C12.3334 5.51046 11.8167 4.24935 10.7834 3.21602C9.75002 2.18268 8.48891 1.66602 7.00002 1.66602C5.51113 1.66602 4.25002 2.18268 3.21669 3.21602C2.18335 4.24935 1.66669 5.51046 1.66669 6.99935C1.66669 8.48824 2.18335 9.74935 3.21669 10.7827C4.25002 11.816 5.51113 12.3327 7.00002 12.3327Z" fill="white"/>
  </svg>
`;

function AddIcon() {
  return (
    <div 
      dangerouslySetInnerHTML={{__html: addIcon}}
      style={{marginRight: '5px', width: '20px', display: 'flex', alignItems: 'center'}}
      className="dropdown-icon-add"
    />
  );
}

class CCDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      pullRight: false,
    };
  }

  getTitle = () => {
    const {
      selectedItems,
      title,
      items,
      valueKey,
      labelKey,
      hasAll,
      multiSelect,
      onlyShowAllText,
      noTranslateLabel,
      hasSelectInitial,
    } = this.props;
    if (!selectedItems || !selectedItems.length) return I18n.t(title);
    if (
      multiSelect &&
      selectedItems.length === items.length &&
      onlyShowAllText &&
      !hasAll
    ) {
      return title
        ? I18n.t(title) + ': ' + I18n.t('General.ALL')
        : I18n.t('General.ALL');
    }
    let selected = filter(items, (item) => {
      if (Array.isArray(selectedItems)) {
        return selectedItems.indexOf(item[valueKey]) !== -1;
      } else {
        return selectedItems === item[valueKey];
      }
    });
    let text = map(selected, (item) =>
      !noTranslateLabel && item[labelKey]
        ? I18n.t(item[labelKey]) || item[labelKey]
        : item[labelKey] || ''
    ).join(', ');
    if (!multiSelect && title) text = I18n.t(title) + ': ' + text;
    if (hasSelectInitial) return `${I18n.t(title)}: ${text}`;
    return text;
  };

  // handle click on menuitem
  // this function callback onSelect function with list of selected eventKey
  handleSelectItem = (eventKey, event, clearAll) => {
    const {
      selectedItems,
      isNumber,
      onSelect,
      multiSelect,
      returnOnSelect,
      items,
      valueKey,
      enableAllItemSelect,
    } = this.props;

    if (clearAll) return onSelect(eventKey);

    let value = isNumber ? parseInt(eventKey) : eventKey;

    if (!multiSelect) {
      if (selectedItems[0] === value) return true;
      return onSelect(value);
    }

    // tra ve option vua click (co the duoc chon hoac khong)
    if (returnOnSelect) return onSelect(value);

    let tmpSelected = cloneDeep(selectedItems);
    let isExist = selectedItems.indexOf(value) !== -1;

    if (enableAllItemSelect && value === 'all_item_auto_render') {
      if (selectedItems.length === items.length) {
        // bo chon tat ca
        let keys = [],
          disableSelectItems = filter(items, (item) => item.disableSelect);
        if (disableSelectItems.length) {
          forEach(disableSelectItems, (item) => {
            if (selectedItems.includes(item[valueKey])) {
              keys.push(item[valueKey]);
            }
          });
        }
        return onSelect(keys);
      } else {
        // chon tat ca
        let allKeys = map(items, (item) => item[valueKey]);
        return onSelect(allKeys);
      }
    }

    if (isExist) {
      remove(tmpSelected, (item) => item === value);
    } else {
      tmpSelected.push(value);
    }

    onSelect(tmpSelected);
  };

  handleToggleClick = (open, event, source) => {
    if (this.props.hasStopPropagation) {
      event.stopPropagation();
    }
    if (this.props.open) return;
    if (source && source.source === 'clearAllItem') {
      return this.setState({ open: false });
    } else {
      if (
        this.props.multiSelect &&
        source.source !== 'rootClose' &&
        this.state.open
      ) {
        return true;
      }
      if (!this.state.open) {
        // let windowWidth = window.innerWidth;
        // let pullRight = false;
        // if (event && event.currentTarget && typeof event.currentTarget.getBoundingClientRect === 'function') {
        //   let domRect = event?.currentTarget?.getBoundingClientRect();
        //   if (windowWidth - domRect.left < 265) pullRight = true;
        // }
        this.setState({ open: true });
      } else {
        this.setState({ open: false });
      }
    }
  };

  render() {
    const {
      id,
      items,
      multiSelect,
      labelKey,
      valueKey,
      enableClearAll,
      selectedItems,
      searchable,
      pullRight,
      customTitle,
      className,
      enableAllItemSelect,
      async,
      onScrollBottom,
      asyncDelay,
      onSearchChange,
      disabled,
      noTranslateLabel,
      applyButton,
      footer,
      customLabel,
      hasActionBtn,
      actionBtnFunc,
      textActionBtn,
      hasIconAdd,
      noTooltip = false,
    } = this.props;
    let menuItems = Object.assign([], items);
    if (enableAllItemSelect && multiSelect)
      menuItems.unshift({
        [valueKey]: 'all_item_auto_render',
        [labelKey]: 'cue.All',
      });

    return (
      <Dropdown
        id={id}
        rootCloseEvent={'click'}
        className={'cc-drop-down ' + (className ? className : '')}
        show={this.props.open ? true : this.state.open}
        onToggle={this.handleToggleClick}
        disabled={disabled}
        alignRight={this.props.alignRight || false}
        drop={this.props.drop || 'bottom'}
      >
        <Dropdown.Toggle disabled={disabled}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {hasIconAdd && <div className="addIcon">+</div>}
            {customTitle ? (
              customTitle
            ) : noTooltip ? (
              <span className="dropdown-title">{this.getTitle()}</span>
            ) : (
              <OverlayTrigger
                overlay={<Tooltip id={'tooltip'}>{this.getTitle()}</Tooltip>}
                placement="top"
                delayShow={300}
                delayHide={150}
              >
                <span className="dropdown-title">{this.getTitle()}</span>
              </OverlayTrigger>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu 
          // flip={false}
        >
          <CustomMenu
            multiSelect={multiSelect}
            enableClearAll={enableClearAll}
            totalSelect={selectedItems.length}
            items={menuItems}
            labelKey={labelKey}
            valueKey={valueKey}
            searchable={searchable}
            onSelect={this.handleSelectItem}
            async={async}
            onScrollBottom={onScrollBottom}
            asyncDelay={asyncDelay}
            onSearchChange={onSearchChange}
            applyButton={applyButton}
            footer={footer}
            hasActionBtn={hasActionBtn}
            actionBtnFunc={actionBtnFunc}
            textActionBtn={textActionBtn}
            disabled={disabled}
          >
            {enableAllItemSelect && multiSelect ? (
              <Dropdown.Item
                eventKey={'all_item_auto_render'}
                className="all-item-auto-added"
              >
                <CcCheckbox
                  checked={selectedItems.length === items.length}
                  value="all_item_auto_render"
                  text={I18n.t('cue.All')}
                  onChange={() => {}}
                  className="dropdown-selectbox"
                  labelClassName="text"
                />
              </Dropdown.Item>
            ) : null}
            {map(items, (item) => {
              let isChecked = multiSelect
                ? selectedItems.indexOf(item[valueKey]) !== -1
                : selectedItems === item[valueKey]
                ? true
                : false;
              return (
                <Dropdown.Item
                  eventKey={item[valueKey]}
                  key={item[valueKey]}
                  disabled={item.disableSelect}
                  className={!multiSelect && isChecked ? 'is-selected' : ''}
                >
                  {multiSelect ? (
                    <CcCheckbox
                      checked={isChecked}
                      value="all"
                      text={
                        !noTranslateLabel && item[labelKey]
                          ? I18n.t(item[labelKey]) || item[labelKey]
                          : item[labelKey] || ''
                      }
                      onChange={() => {}}
                      className="dropdown-selectbox text-ellipsis"
                      labelClassName="text"
                      disabled={item.disableSelect}
                    />
                  ) : (
                    <span className="text">
                      {customLabel
                        ? customLabel(item)
                        : !noTranslateLabel && item[labelKey]
                        ? I18n.t(item[labelKey]) || item[labelKey]
                        : item[labelKey] || ''}
                    </span>
                  )}
                </Dropdown.Item>
              );
            })}
          </CustomMenu>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

CCDropDown.propTypes = {
  items: PropTypes.array.isRequired,
  multiSelect: PropTypes.bool,
  id: PropTypes.string,
  title: PropTypes.string,
  hasAll: PropTypes.bool,
  selectedItems: PropTypes.array.isRequired,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  searchable: PropTypes.bool,
  isNumber: PropTypes.bool,
  onSelect: PropTypes.func,
  enableClearAll: PropTypes.bool,
  returnOnSelect: PropTypes.bool,
  pullRight: PropTypes.bool,
  customTitle: PropTypes.any,
  className: PropTypes.string,
  enableAllItemSelect: PropTypes.bool, // tu dong them item All,
  onlyShowAllText: PropTypes.bool,
  async: PropTypes.bool,
  onScrollBottom: PropTypes.func,
  asyncDelay: PropTypes.number,
  onSearchChange: PropTypes.func,
  disabled: PropTypes.bool,
  noTranslateLabel: PropTypes.bool,
  applyButton: PropTypes.func,
  footer: PropTypes.bool,
  customLabel: PropTypes.func, // custom label for item
};

export default CCDropDown;
